import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useKato } from '../../../../contexts/kato.context';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../../components/card/card.component';
import { useShared } from '../../../../contexts/shared.context';
import { FoodSubType, IBasicStats, ICardName } from '../../../../types/kato.types';
import classes from './styles.module.scss';
import { FoodSubTypeToIcon } from '../../../../consts/other.conts';

const translationKey = 'cards.food-card';
const baseClass = 'food-card';

const FoodCard = () => {
    const { t, i18n: { language } } = useTranslation();
    const { basicStats } = useKato().katoGeneralInfo;
    const { kato, link, tab } = useParams<{ kato: string; link: string; tab: string }>();
    const { setFullscreen, selectedInfoYear } = useShared();
    const navigate = useNavigate();
    const [valName, setValName] = useState<'currentYearVal' | 'previousYearVal'>('currentYearVal');
    const [sortedData, setSortedData] = useState<IBasicStats[]>([]);

    // const data = (basicStats || []).filter(item => item.type === 'FOOD');

    useEffect(() => {
        if (basicStats) {
            const data = (basicStats || []).filter(item => item.type === 'FOOD') as IBasicStats[];
            setSortedData([...data].sort((a, b) => (b[valName] ?? 0) - (a[valName] ?? 0)));
        }
    }, [basicStats, valName]);

    const years = [
        { label: +selectedInfoYear - 1, value: 'previousYearVal' },
        { label: +selectedInfoYear, value: 'currentYearVal' }
    ] as const;

    const onClick = () => {
        setFullscreen({ open: true, type: ICardName.FOOD });
        navigate(`/${kato}/${link}/${tab}/${ICardName.FOOD}`);
    };

    if (!basicStats || !selectedInfoYear || !sortedData.length) return null;

    return (
        <Card title={t(`${translationKey}.title`)} onClick={onClick}>
            <div className={classes[baseClass]}>
                <div className={classes[`${baseClass}__years`]}>
                    {
                        language === 'ru' && <div className={classes[`${baseClass}__years__text`]}>посмотреть отчет за:</div>
                    }
                    {years.map((year) => (
                        <div
                            key={year.value}
                            className={`${classes[`${baseClass}__years__btn`]} ${valName === year.value ? classes['active'] : ''
                                }`}
                            onClick={() => setValName(year.value)}
                        >
                            {year.label}
                        </div>
                    ))}
                    {
                        language === 'kz' && <div className={classes[`${baseClass}__years__text`]}>есепті қарау</div>
                    }
                </div>

                <div className={classes[`${baseClass}__grid`]}>
                    {sortedData.map((item) => {
                        const value = item[valName];
                        return (
                            <div key={item.subType} className={classes[`${baseClass}__grid__item`]}>
                                <span className={classes[`${baseClass}__grid__icon`]}>
                                    {FoodSubTypeToIcon[item.subType as FoodSubType] ?? ''}
                                </span>
                                <span className={classes[`${baseClass}__grid__title`]}>
                                    {t(`${translationKey}.${item.subType}`)}
                                </span>
                                <span className={classes[`${baseClass}__grid__value`]}>
                                    {typeof value === 'number' ? `${value}%` : '—'}
                                </span>
                            </div>
                        );
                    })}
                </div>
            </div >
        </Card >
    );
};

export default FoodCard;
